//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'EventCard',
  props: ['data'],
  data() {
    return {
      // data: [{}],
    };
  },
  computed: {},
};



// WEBPACK FOOTER //
// ./scripts/vue/WhdThuisCard.vue